import React, { memo, useMemo } from 'react'
import tw from 'twin.macro'
import { RowActionsMenu } from 'src/components/shared/grid/RowActionsMenu'
import type { OnboardingTemplate } from 'src/interfaces/onboardingTemplate'
import type { MenuActionItem } from 'src/interfaces/ui'
import { GSIcon } from 'src/components/shared/GSIcon'

const DELETE_NO_PERMISSION_REASON = "You don't have permission to delete onboarding templates."

interface Props {
  template: OnboardingTemplate
  canDelete: boolean
  onOpen(template: OnboardingTemplate): void
  onDelete(template: OnboardingTemplate): void
}

const OnboardingTemplateActionsCellComponent = ({
  template,
  canDelete,
  onOpen,
  onDelete,
}: Props) => {
  const items = useMemo<MenuActionItem[]>(() => {
    return [
      {
        label: 'Edit steps',
        icon: <GSIcon iconName="gs_pencil" size={20} css={tw`text-shades-1000`} />,
        dataTestId: `onboarding-templates-list-open-${template.id}`,
        onClick: () => {
          onOpen(template)
        },
      },
      {
        label: 'Delete',
        icon: <GSIcon iconName="gs_trash_can" size={20} css={tw`text-critical-500`} />,
        color: 'var(--mui-critical-500)',
        disabled: !canDelete,
        disabledReason: canDelete ? undefined : DELETE_NO_PERMISSION_REASON,
        dataTestId: `onboarding-templates-list-delete-${template.id}`,
        onClick: () => {
          onDelete(template)
        },
      },
    ]
  }, [template, canDelete, onOpen, onDelete])

  return (
    <RowActionsMenu
      items={items}
      ariaLabel="Onboarding template actions"
      dataTestId={`onboarding-templates-list-actions-${template.id}`}
    />
  )
}

export const OnboardingTemplateActionsCell = memo(OnboardingTemplateActionsCellComponent)
